module.exports = __webpack_public_path__ + "static/img/Round-19-2011.899172d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-19-2011.jpg
// module id = 2DkR
// module chunks = 0